export default __webpack_public_path__ + "static/media/results-example-2.a11330bf.png";